export const BaseDict = {
    MyPulseBets: "My Pulse Bets",
    PlaceBet: "Place Pulse Bet",
    PleaseLoginToPlaceBet: "LOGIN TO BET",
    PulseBetInterval: "1 min Pulse",
    TimeIsSeconds: "Sec",
    ErrorMessage: "Error message",
    StartsLabel: "Starts In",
    GoLabel: "Go",
    GermanTaxesMessage: "In accordance with German tax law, {0} % tax will be deducted your total return.",
    GeneralMessage: "This is general message",
    BetWasAccepted: "Your bet was accepted",
    TicketLabel: "Ticket",
    GoToMyPulseBets: "Go to my pulse bets",
    Suspended: "Suspended",
    Sec: "Sec",
    Branch1_1441_: "",
    Branch1_1442_: "",
    Branch1_1443_: "",
    Branch1_1444_: "",
    UseFreeBets: "Use Free Bet",
    UseMyBalance: "Use My Balance",
    SelectFreeBet: "Select Free bet"
};
//# sourceMappingURL=dict.js.map